<template>
  <b-modal
    id="modal-workplace-launch"
    ref="workplaceLaunchModal"
    :title="workplaceLaunchMode.workplace_name ? `Editar Tipo de Lançamento de Plantão (${workplaceLaunchMode.workplace_name})` : ''"
    hide-footer
    centered
  >
    <div class="pb-2">
      <p class="mb-0">
        Tipo Lançamento
      </p>
      <div class="-d-flex">
        <div class="w-100">
          <v-select
            id="launch-mode"
            v-model="workplaceLaunchMode.physician_duty_launch_mode"
            name="launch-mode"
            :options="launchModeOptions"
            label="label"
            item-value="value"
            item-text="label"
            :clearable="false"
          />
        </div>
        <div class="w-100 text-right">
          <b-button
            variant="primary"
            class="mt-3 -w-100"
            :disabled="loading"
            @click="editLaunchMode"
          >
            <span class="d-none d-sm-inline">Confirmar</span>
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BButton, BModal, VBModal } from 'bootstrap-vue'
import vSelect from 'vue-select'
import useWorkplaceLaunch from './useWorkplaceLaunch'

export default {
  components: {
    BButton,
    BModal,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
  },
  setup(_, { emit }) {
    const {
      loading,
      workplaceLaunchModal,
      workplaceLaunchMode,
      launchModeOptions,
      show,
      editLaunchMode,
    } = useWorkplaceLaunch(() => emit('refetch-data'))

    return {
      loading,
      workplaceLaunchModal,
      workplaceLaunchMode,
      launchModeOptions,
      show,
      editLaunchMode,
    }
  },
}
</script>
